export default "__VITE_PUBLIC_ASSET__6e0000c7__"